import {
    getCustomers,
    deleteCustomer,
    createCustomer,
    updateCustomer,
    getReportCustomers
} from '../../../services/CustomerService';
import {
    CONFIRMED_GET_CUSTOMERS
} from './CustomerTypes';

export function getCustomersAction(currentPage, pageSize, searchTerm, filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_CUSTOMER_LOADING', payload: true });
        getCustomers(currentPage, pageSize, searchTerm, filterQuery)
            .then((response) => {
                dispatch(confirmedGetCustomersAction(response.data.data));
            })
            .finally(() => {
                dispatch({ type: 'SET_CUSTOMER_LOADING', payload: false });
            });
    };
}

export function getReportCustomersAction(filterQuery) {
    return (dispatch, getState) => {
        dispatch({ type: 'SET_CUSTOMER_LOADING', payload: true });
        getReportCustomers(filterQuery).then((response) => {
            dispatch(confirmedGetCustomersAction(response.data.data));
        }).finally(() => {
            dispatch({ type: 'SET_CUSTOMER_LOADING', payload: false });
        });
    };
}

export function confirmedGetCustomersAction(data) {
    return {
        type: CONFIRMED_GET_CUSTOMERS,
        payload: data,
    };
}

export function deleteCustomerAction(id, history) {
    return (dispatch, getState) => {
        return deleteCustomer(id).then((response) => {
            return response;
        });
    };
}

export function createCustomerAction(data) {
    return () => {
        return createCustomer(data).then((response) => {
            return response;
        });
    };
}

export function updateCustomerAction(id, data) {
    return () => {
        return updateCustomer(id, data).then((response) => {
            return response;
        });
    };
}


